import { useEffect } from "react";

// Nombre de tiroirs ouverts : la classe ne tombe que lorsque le dernier se ferme.
let openCount = 0;
const CLASS = "lite-drawer-open";

/** Masque le lanceur de support (Botpress, z-index 9999) tant qu'un tiroir Lite est ouvert :
 *  sinon il recouvre le pied du tiroir sur mobile (règle CSS `body.lite-drawer-open` dans Main.css). */
export function useHideSupportLauncher(open: boolean) {
  useEffect(() => {
    if (!open) return;
    openCount += 1;
    document.body.classList.add(CLASS);
    return () => {
      openCount = Math.max(0, openCount - 1);
      if (openCount === 0) document.body.classList.remove(CLASS);
    };
  }, [open]);
}
